export const config = {
  title: "Anthony Ross | Ross Realty Group Inc.",
  meta: {
    description:
      "Work with Anthony Ross of Ross Realty Group Inc. for buying, selling, and leasing homes in Toledo, OH and surrounding areas.",
    keywords: [
      "Anthony Ross Realtor",
      "Ross Realty Group Inc",
      "Toledo real estate",
      "buy a home Toledo",
      "sell your home Toledo",
      "property listings Toledo OH"
    ],
    author: "Anthony Ross | Ross Realty Group Inc.",
    canonicalUrl: "https://www.ross-realtygroup.com/",
  },

  sections: {
    header: {
      businessName: "Anthony Ross | Ross Realty Group Inc.",
    },

    sectionB: {
      heroTitle: "Your Toledo Real Estate Partner",
      heroSubtitle: "Buying • Selling • Leasing across Northwest Ohio",
      learnAboutText: "Browse Listings",
      phoneNumber: "4197047958",
      phoneLabel: "(419) 704-7958",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2164822692/photo/suburban-sprawl.jpg?s=612x612&w=0&k=20&c=Z1eiTgQPjSVSpTwcNr7gcvIcBX8lMjCHeV_iDxqWONA=",
      cardData: [
        {
          title: "Home Buying",
          description:
            "Search, tour, and negotiate the right home—backed by local expertise.",
        },
        {
          title: "Home Selling",
          description:
            "Pricing strategy, marketing, and negotiations to maximize your sale.",
        },
        {
          title: "Investment & Leasing",
          description:
            "Support for investors and landlords, from acquisition to tenant placement.",
        },
      ],
      description:
        "Based at Ross Realty Group Inc., Anthony Ross serves buyers, sellers, and investors with responsive communication and deep local market knowledge in Toledo, OH.",
    },

    sectionC: {
      servicesTitle: "Services",
      servicesDescription:
        "Full-service representation tailored to your goals.",
      cards: [
        {
          title: "Buyer Representation",
          description:
            "Neighborhood insights, comps, and offer strategy from search to close.",
          imageSrc: "https://media.istockphoto.com/id/2189337416/photo/business-persons-discussing-financial-plan.jpg?s=612x612&w=0&k=20&c=nOYBVXf6nDZeCVxHEmCpMBXIuKMtAxS5tlldGztalgE=",
          imageAlt: "Buyer tour",
        },
        {
          title: "Listing Services",
          description:
            "Home prep guidance, photography, MLS exposure, and offer management.",
          imageSrc: "https://media.istockphoto.com/id/2161058041/photo/two-businessmen-working-on-a-digital-tablet-and-laptop-computer-in-the-office.jpg?s=612x612&w=0&k=20&c=oeEgzLz38lQuN10IT9SWNQuSUEVIvajyrTaiS7fHP1k=",
          imageAlt: "For sale sign",
        },
        {
          title: "Investor Support",
          description:
            "Renovation ROI guidance, rental analysis, and portfolio growth.",
          imageSrc: "https://media.istockphoto.com/id/881542122/photo/business-people-using-pen-tablet-notebook-are-planning-a-marketing-plan-to-improve-the-quality.jpg?s=612x612&w=0&k=20&c=zSo6zX4zgsOYBQpw_7Xcz3nX_sXqwHr0mSzEGkUREUg=",
          imageAlt: "Investment property",
        },
      ],
      otherServicesTitle: "Additional Help",
      otherServicesList: [
        "Home Valuation",
        "Market Reports",
        "Open House Coordination",
        "Vendor & Lender Referrals",
      ],
    },

    sectionD: {
      aboutTitle: "About Anthony",
      aboutImage: {
        src: "https://www.ross-realtygroup.com/wp-content/uploads/sites/24751/2025/08/AnthonyRossBroker-450x450.png",
        alt: "Anthony Ross – Ross Realty Group Inc.",
      },
      aboutText: [
        "Anthony Ross is a Toledo-based REALTOR® with Ross Realty Group Inc., focused on clear communication, data-backed pricing, and smooth transactions.",
        "Clients appreciate timely updates and local expertise across neighborhoods and property types.",
      ],
    },

    sectionE: {
      profileImage: null,
      profileAlt: "Ross Realty Group Inc. Logo",
      businessName: "Anthony Ross | Ross Realty Group Inc.",
      contact: {
        phone: "4197047958",
        phoneLabel: "(419) 704-7958",
        email: "anthonyhross@yahoo.com",
        website: "https://www.ross-realtygroup.com/",
        address: "1837 Eastgate Rd, Toledo, OH 43614",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        zillow: null,
      },
    },

    sectionF: {
      address: "1837 Eastgate Rd, Toledo, OH 43614",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=1837+Eastgate+Rd,+Toledo,+OH+43614&output=embed",
    },
  },
};

export default config;
